export default "__VITE_ASSET__DrlsJF4I__"